import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { StyledDatePicker, StyledToobar } from "./DatePicker.style";
import TimePicker from "react-multi-date-picker/plugins/analog_time_picker";
import { DATE_FORMATS } from "helper/date";
import { TextField } from "@mui/material";

export default function DatePickerCM(props) {
  const type = props.type ?? "Date";

  const plugins = {
    Date: [
      <DatePanel />,
      <StyledToobar
        names={{ close: "تایید", today: "امروز" }}
        position="bottom"
      />,
    ],
    Time: [
      <TimePicker hideSeconds />,
      <StyledToobar
        names={{ close: "تایید", today: "الان" }}
        position="bottom"
      />,
    ],
    Both: [<TimePicker hideSeconds />],
  };

  const format = {
    Time: DATE_FORMATS.faTime,
    Date: DATE_FORMATS.faDate,
    Both: DATE_FORMATS.faDateTime,
  };
  return (
    <StyledDatePicker
      ref={props.useref}
      value={props.value}
      onChange={(val) => props.onChange && props.onChange(val)}
      calendar={persian}
      locale={persian_fa}
      calendarPosition="top"
      range={props.range}
      minDate={props.mindate}
      disableDayPicker={type === "Time"}
      format={format[type]}
      plugins={plugins[type]}
      render={
        !props.render
          ? (value, openCalendar) => {
              return (
                <TextField
                  label={props.label || "تاریخ"}
                  variant="outlined"
                  fullWidth
                  id={props.id}
                  {...props.register(props.id)}
                  error={Boolean(props?.errors?.[props.id])}
                  helperText={props?.errors?.[props.id]?.message}
                  value={value ? value : ""}
                  onClick={openCalendar}
                />
              );
            }
          : props.render
      }
    />
  );
}
